const Req = window.Req;
Req.localPath = Req.localPath || '/skin/v1/pub/';
import cfg from './config.json';

Req(
	'mobilefix', // <-- fixes rotation zoom bug in Mobile Safari, and scrolls page down to hide url bar...

	'eutils',
	'ga',
	'x/cookie',

	'autovalidate',
	'selectybox',
	'labelizor',
	// 'prettynum',
	// 'fieldsetcloner',
	'x/ui-datepicker 1.11',
	'x/ui-autocomplete 1.11',

	'onformatchange',
	'mobilemenu',
	'query',
	// 'whenonscreen',
	// 'virtualBrowser',

	// 'equalizeheights',
	// 'listscroller',
	'treecollapse',
	'delayedhighlight',

	// 'fickle 2',
	// 'getmodal',
	'imgpop 2',
	'tabswitcher',

	// 'q-alistdatesplit',
	'q-quickfeedback',
	'q-editedsearch',
	'q-yearindextoggler',
	'q-slidenav',
	'q-paginazor',

	'mailtoenabler',
	'anchortags',

	function() {
		'use strict';

		const $ = window.jQuery;

		const $html = $('html');

		const $win = $(window);
		// var $body = $( 'body' );
		const $doc = $(document);

		// var $pginner = $('.pginner');
		const $pgmain = $('.pgmain');
		const $mnav = $('.mnav');
		const $enav = $('.enav');
		const $qlinks = $('.qlinks > ul');
		const $qsearch = $('.qsearch');

		const formatMonitor = $.formatChange(
			window.FormatChange.makeGroups(cfg.mediaFormats)
		);
		const media = formatMonitor.media;

		const i18n = { en: {} };
		i18n.is = $.beget(i18n.en);
		const txt = i18n[$('html').attr('lang')] || i18n.en;

		// =========================================================================================================================
		//   Default Configs
		// =========================================================================================================================

		const loggedIn = window.EPLICA_loggedin;
		const noop = $.noop;

		// Helpers for session and local storage
		const db = {};
		db.ls = window.localStorage;
		db.ss = window.sessionStorage;
		db.get = !db.ss
			? noop
			: function(storage, key) {
					return JSON.parse(db[storage].getItem(key) || '{}');
			  };
		db.set = !db.ss
			? noop
			: function(storage, key, data) {
					const dataStr = JSON.stringify(data);
					db[storage].setItem(key, dataStr);
			  };
		db.remove = !db.ss
			? noop
			: function(storage, key) {
					db[storage].removeItem(key);
			  };

		// responsive images
		const $image = $('ins.image');
		if ($image.length) {
			$win
				.on('formatchange.imagebanner', function(/*e*/) {
					$image.each(function() {
						if (media.format === 'phone' || media.format === 'phablet') {
							$(this).css({
								'background-image': 'url(' + $(this).attr('data-imgsmall') + ')',
							});
						} else if (media.format === 'tablet' /* || media.format === 'netbook'*/) {
							$(this).css({
								'background-image': 'url(' + $(this).attr('data-imgmedium') + ')',
							});
						} else {
							$(this).css({
								'background-image': 'url(' + $(this).attr('data-imglarge') + ')',
							});
						}
					});
				})
				.trigger('formatchange.imagebanner');
		}

		const scrollTo = function(target, duration) {
			const offset = media.isHeaderLarge ? 95 : 0;
			const targetTop =
				target && target.length ? Math.round(target.offset().top) - offset : 0;
			duration = duration || 250;

			$('html, body').animate({ scrollTop: targetTop }, duration, 'swing', function() {
				if (targetTop !== 0) {
					$html.removeClass('is-header-shown');
				}
			});
		};

		// =========================================================================================================================
		//   Actions
		// =========================================================================================================================

		const prepHeader = function() {
			const aTitle = $('.twocol .pgmain, .onecol .pgmain')
				.find('h1, .boxhead')
				.first();
			if (aTitle.length) {
				$('.pgtop').append(aTitle);
			}
		};

		const tagFileAndExternalLinks = function(root) {
			i18n.en.newWindow = 'Opens in new window';
			i18n.is.newWindow = 'Opnast í nýjum vafraglugga';
			i18n.en.fileText = 'file';
			i18n.is.fileText = 'skjal';

			root.query('a:not(.videolink)').anchorTags({
				usePatterns: ['doc', 'pdf', 'xls'],
				localDomains: ['^.eplica.is', '^.gardabaer.is'],
				onTag: function(link, is) {
					const text = is.pattern
						? is.pattern[0].toUpperCase() + ' ' + txt.fileText
						: is.external
						? txt.newWindow
						: '';
					text &&
						link
							.attr('target', '_blank')
							.attr(
								'title',
								$.trim(link.attr('title') || link.text()) + ' (' + text + ')'
							);

					const gaCat = is.external
						? 'external'
						: is.tel
						? 'telephone'
						: is.mailto
						? 'email'
						: is.pattern
						? 'download'
						: '';
					if (window.ga && gaCat) {
						link.on('click', function(/*e*/) {
							window.gaHXM.eventPing(
								gaCat,
								is.pattern ? 'click-' + is.pattern[0] : 'click',
								link.attr('href').replace(/^(tel|mailto):/i, ''),
								1,
								is.external ? true : false
							);
						});
					}
				},
			});
		};

		const _openImagesInModal = function(article) {
			article
				.find('.imagebox a.img,.flickr a')
				.filter('a.img')
				.each(function() {
					const imgsrc = $(this)
						.find('img')
						.attr('src')
						.replace(/\/[^/]+\/([^/]+)$/, '/large/$1');
					$(this).attr('href', imgsrc);
				})
				.end()
				.imgPopper();
		};

		const _enhanceVideolinks = function(article) {
			article.find('a.videolink').Req('q-videolinks', function() {
				$(this).videoLinks();
			});
		};

		const _enhanceAudiolinks = !('src' in $('<audio/>')[0])
			? noop
			: function(article) {
					article.find('a.audioplayer').each(function(i, link) {
						$('<audio/>')
							.prop({
								src: link.href,
								preload: 'none',
								controls: true,
							})
							.insertBefore(link)
							.append(link);
					});
			  };

		const _injectShareBtns = function(article) {
			const shareText = article.is('.news')
				? 'Deildu þessari frétt:'
				: article.is('.event')
				? 'Deildu þessum viðburði:'
				: '';
			Req('sharebtns', function() {
				const shareWidgets = $('<ul class="share-widgets" />')
					.sharebtns({
						wrap: 'li',
						custom: true,
						// countNone: true,
						twitter: 3,
						gplus: 4,
						// pinterest: 3,
						fbshare: 1,
						facebook: false,
						linkedin: 2,
						email: 5,
					})
					.end();
				const shareBar = $(
					'<div class="share-bar"><h3>' + shareText + '</h3></div>'
				).append(shareWidgets);

				if (article.find('.paging').length) {
					article.find('.paging').before(shareBar);
				} else {
					shareBar.appendTo(article.find('.boxbody'));
				}
			});
		};

		const _collapseCollapseBlocks = function(article) {
			article.find('.collapse').each(function() {
				const head = $(this).addClass('collapse-active collapse-closed');
				head
					.nextUntil('h2, h3, hr, .buttons, .share-widgets, .paging')
					.wrapAll('<div class="collapseouter" style="display: none" />')
					.wrapAll('<div class="collapsebox" />');
				head.wrapInner('<a href="#" />').on('click', function(e) {
					head
						.toggleClass('collapse-closed')
						.next()
						.slideToggle('fast');
					e.preventDefault();
				});
			});
		};

		const _makeTabBoxFromTabHeaders = function(article) {
			article.find('.tabhead').each(function() {
				const head = $(this).addClass('tabhead-active');
				head
					.nextUntil('h2, hr, .buttons, .share-widgets, .paging')
					.addBack()
					.wrapAll('<div class="tabwrap" />');
			});
			article
				.find('.tabwrap')
				.makeTabbox()
				.tabSwitcher();
		};

		const _enhanceChapters = function(article) {
			const chapters = article.find('.chapters');
			if (chapters.length) {
				chapters.on('click', 'a', function(e) {
					e.preventDefault();
					const targetId = $(this)
						.attr('href')
						.replace('#', '');
					$.setFrag(targetId);
					scrollTo($(document.getElementById(targetId)));
				});

				if (media.isHeaderLarge && $('.pgextra1').length) {
					chapters
						.addClass('snav box')
						.find('h2')
						.addClass('boxhead');
					$('.pgextra1').append(chapters);
				}
			}
		};

		const _initLocationArticle = function(article) {
			article
				.find('h1,.subtitle')
				.wrapAll('<div class="twrap" />')
				.parent()
				.appendTo(article.find('.imagebox'));
			article
				.find('.summary')
				.wrapAll('<div class="twrap2" />')
				.parent()
				.prependTo(article);

			article
				.find('.imagebox')
				.prependTo(article)
				.find('img')
				.each(function() {
					$(this).attr('data-original', $(this).attr('src'));
				});

			const mapbox = $('.mapsbox')
				.addClass('gmaps')
				.wrapInner('<div class="inner"></div>');
			article.find('.boxbody').append(mapbox);

			$win
				.on('formatchange.imgswap', function(/*e*/) {
					article.find('.imagebox img').each(function() {
						if (media.format === 'phone' || media.format === 'phablet') {
							$(this).attr('src', $(this).attr('data-original'));
						} else if (media.format === 'tablet' /* || media.format === 'netbook'*/) {
							$(this).attr(
								'src',
								$(this)
									.attr('data-original')
									.replace('small', 'medium')
							);
						} else {
							$(this).attr(
								'src',
								$(this)
									.attr('data-original')
									.replace('small', 'large')
							);
						}
					});
				})
				.trigger('formatchange.imgswap');
		};

		const prepArticleContent = function(root) {
			root.query('.article').each(function() {
				const article = $(this);
				_collapseCollapseBlocks(article);
				_makeTabBoxFromTabHeaders(article);
				_openImagesInModal(article);
				_enhanceVideolinks(article);
				_enhanceAudiolinks(article);
				_enhanceChapters(article);

				if (article.is('.location')) {
					_initLocationArticle(article);
				}

				if (article.is('.news') || article.is('.event')) {
					_injectShareBtns(article);
				}
			});
		};

		const prepArticlelists = function(root) {
			root.query('.articlelist').each(function() {
				const alist = $(this);
				// var alistTitle = $(this).find('.boxhead');
				// $('.pgtop').append(alistTitle);

				i18n.en.moreItemsText = 'Load more articles';
				i18n.is.moreItemsText = 'Hlaða fleiri greinum';

				if (alist.is('.imgcards')) {
					alist.find('.item').each(function() {
						$(this)
							.find('>*:not(.img)')
							.wrapAll('<div class="text" />');
					});
					alist.addClass('imgcards-active');
				}

				if (alist.is('.highlights')) {
					alist.find('.item').each(function() {
						$(this)
							.find('> .img')
							.append($(this).find('> h3'));
					});
				}

				if (alist.is('.newslist')) {
					i18n.en.moreItemsText = 'Load more news';
					i18n.is.moreItemsText = 'Hlaða fleiri fréttum';

					// change March 2021 by request by client, start showing
					//   years again, to avoid confusion when using tag-filters and
					//   displaying the resulting cross-years list.

					// alist
					// 	.on('listupdated', function(e, data) {
					// 		window.console.log(data);
					// 		$(data.itemlist).each(function() {
					// 			const dateElm = $(this).find('.meta .date');
					// 			const date = dateElm.text().replace(/\d{4}/, '');
					// 			dateElm.text(date);
					// 		});
					// 	})
					// 	.trigger('listupdated', [{ itemlist: alist.find('.item') }]);
				}

				if (alist.is('.eventlist')) {
					i18n.en.moreItemsText = 'Load more events';
					i18n.is.moreItemsText = 'Hlaða fleiri viðburðum';

					alist
						.on('listupdated', function(e, data) {
							$(data.itemlist).each(function() {
								const dateElm = $(this).find('.meta .date');
								const date = dateElm.text().replace(/\W{2}\s\d{4}/g, '');
								dateElm.text(date);
							});
						})
						.trigger('listupdated', [{ itemlist: alist.find('.item') }]);
				}

				if (alist.find('.paging').length) {
					const isMonthView = /\/\d{4}\/\d{2}$/.test(document.location.href);

					alist.find('.boxbody').paginazor({
						loadLazyImages: true,
						infinityLoad: isMonthView ? true : 'notfirst',
						loadMoreText: txt.moreItemsText,
					});
				}
			});
		};

		// turn old-school input buttons into proper <button> elements
		const _enforceButtonElms = function(root) {
			root.find('input:submit, input:reset').each(function() {
				const inp = $(this);
				$('<button>')
					.attr({
						type: inp.attr('type'),
						name: inp.attr('name'),
					})
					.text(inp.val())
					.replaceAll(inp);
			});
		};

		const _activateCheckboxAndRadios = function(root) {
			root
				.query('.fi_chk, .fi_rdo')
				.on('change.markparent', 'input:radio, input:checkbox', function(/*e*/) {
					const input = this;
					const $input = $(input);
					if (input.type === 'radio') {
						$input
							.closest('.fi_rdo')
							.find('.active')
							.removeClass('active');
					}
					$input.closest('li, .fi_chk').toggleClass('active', input.checked);
				})
				.find('input:checked')
				.trigger('change.markparent');
		};

		const initForms = function(root) {
			root.find('#qstr').labelizor(); // labelize .qsearch input
			_enforceButtonElms(root);
			_activateCheckboxAndRadios(root);
			root
				.find('input[type="tel"]')
				.constrainNumberInput(/*{ selector:'input[type="tel"]', arrows:true }*/);
			root.find('select').selectybox();
			// validate all forms
			root.query('form').autoValidate({
				errorMsgType: 'inlineonly',
				validateEachField: 'change',
			});
		};

		const handleTelephoneLinks = function() {
			// depends on formatChange()
			i18n.is.callPrompt = 'Hringja í ';
			i18n.en.callPrompt = 'Call ';
			$doc.on('click', 'a[href^="tel:"]', function(e) {
				if (media.isLarge) {
					const m = $(this)
							.text()
							.match(/\+?\d[\s\-\d]+\d/),
						num = (m && m[0]) || this.href.substr(4);
					if (!confirm(txt.callPrompt + num + ' ?')) {
						e.preventDefault();
					}
				}
			});
		};

		const _closeMnav = function() {
			$html.removeClass('mnav-open');
			$mnav.find('.active').removeClass('active');
		};

		const initMnav = function() {
			i18n.is.searchTxt = 'Leita';
			i18n.en.searchTxt = 'Search ';
			// var searchTrigger = $('<a class="searchbtn" href="#">'+ txt.searchTxt +'</a>');

			// searchTrigger.on('click', function (e) {
			//     e.preventDefault();
			//     if ( $html.is('.is-menu-open') ) {
			//       $('.skiplink a').trigger('click.toggle-mobilemenu');
			//     }
			//     $html.toggleClass('qsearch-active');

			//     if ( $html.is('.qsearch-active') ) {
			//       $qsearch.find('.fi_txt input').focus();
			//     }
			//   });

			$win
				.on('formatchange.mnav', function(/*e*/) {
					if (media.becameHeaderSmall) {
						// cleanup desktop
						$html.removeClass('mnav-open');
						$mnav.find('.active').removeClass('active');
						$mnav.find('.mega').zap();
						$mnav.off('click.mnav', '.level1 > li.branch > a');

						// $('.pghead .wrap').append(searchTrigger);
						// $qsearch.appendTo($('.pgextra2 .wrap'));

						// init mobile
						$mnav.slideNav({
							branch: '.level1 > li.branch, .level2 > li.branch',
							doTogglers: false,
							toggler: '> a',
							cloneBranchClass: true,
							linkTitle: false,
						});

						if ($qlinks.length) {
							// basically if .home
							$enav.find('li').each(function(/*i, elm*/) {
								$(this)
									.clone()
									.addClass('from-enav')
									.insertBefore($qlinks.find('li.first'));
							});
						}

						if (!$mnav.is('.tree-active')) {
							$mnav
								.addClass('tree-active')
								.find('ul.level3')
								.treeCollapse({
									branch: 'li:has(ul)',
									doTogglers: 1,
									doSelect: 1,
									toggler: '> a.expand',
									startOpen: 'li.parent:has(ul), li.current:has(ul)',
								});
						}

						$('.skiplink a').on('click.slNav', function(/*e*/) {
							$html.removeClass('qsearch-active');
							setTimeout(function() {
								$win.trigger('resize.slNav');
							}, 10);
						});
					} else if (media.becameHeaderLarge) {
						// cleanup mobile
						$mnav.slideNav('destroy');
						$('.skiplink a').off('click.slNav');

						if ($qlinks.length) {
							$qlinks.find('.from-enav').remove();
						}

						// searchTrigger.detach();
						$qsearch.appendTo('.pgextra2 .navwrap .wrap');
						$enav.appendTo('.pgextra2 .navwrap .wrap');

						// init desktop
						$mnav.on('click.mnav', '.level1 > li.branch > a', function(e) {
							e.preventDefault();
							if (
								$(this)
									.parent()
									.is('.active')
							) {
								_closeMnav();
							} else {
								$html.addClass('mnav-open');
								$mnav.find('.active').removeClass('active');
								$(this)
									.parent('li')
									.addClass('active');
							}
						});
						$mnav.find('.level2').wrap('<div class="mega" />');
					}
				})
				.trigger('formatchange.mnav');

			$win.on('keyup', function(e) {
				if (e.which === 27) {
					if (media.isHeaderLarge) {
						_closeMnav();
					} else if (media.isHeaderSmall && $html.is('.is-menu-open')) {
						$('.skiplink a').trigger('click.toggle-mobilemenu');
					}
					$html.removeClass('qsearch-active');
				}
			});
		};

		/*
    var insertPageStylesButtons = function () {
            $.makePageStyles({
                // appendTo:     'body',
                // fontsizeBtns: true,
                // userstyles:   false
              });
          };
*/

		const collapseSitemap = function() {
			$('.sitemap').treeCollapse({
				branch: 'li:has(ul)',
				doTogglers: 1,
				toggler: '> a.expand',
				startOpen: 'ul.level1 > li:has(ul)',
			});
		};

		const initNavScroll = function() {
			$win
				.on('formatchange.navScroll', function(/*e*/) {
					if (media.becameHeaderLarge) {
						$win
							.on(
								'scroll.navScroll',
								$.throttleFn(function(/*e*/) {
									if (
										($html.is('home') && $win.scrollTop() > 120) ||
										(!$html.is('home') && $win.scrollTop() > 50)
									) {
										$html.addClass('header-fixed');
									} else {
										$html.removeClass('header-fixed');
									}
								})
							)
							.trigger('scroll.navScroll');
					} else if (media.leftHeaderLarge) {
						$win.off('scroll.navScroll');
					}
				})
				.trigger('formatchange.navScroll');
		};

		const prepYearindex = function() {
			const yindex = $('.yearindex');
			const tagnav = $('.tagnav');
			if (yindex.length) {
				yindex.find('.boxbody').yearindexToggler({
					bemPrefix: 'yearindexfilter',
					shortMonths: true,
				});

				if (tagnav.length) {
					yindex.append(tagnav.removeClass('box'));
				}

				/* // hliðarbar er of hár, verður bara skrítið þegar þetta scrollar með manni. Hlekkir verða ekki aðgengilegir fyrr en maður scrollar niður í botn.
            var bheight;
            var mt = 0;
            $win.on('formatchange.yindex', function (/*e* /) {
                bheight =  $pgmain.outerHeight() - yindex.outerHeight() - 170;
                if ( media.becameLarge ) {
                  $win.on('scroll.yindex', function (/*e* /) {
                      if ( $(window).scrollTop() > 170 && mt <= bheight ) {
                        mt = $(window).scrollTop() - 170;
                        // yindex.removeClass('attop');
                      }
                      else if ( mt > bheight ) {
                        mt = bheight;
                      }
                      else {
                        mt = 0;
                        // yindex.addClass('attop');
                      }

                      //Fixme: previous if's can go out of bounds?
                      if ( mt > bheight ) {
                        mt = bheight;
                      }
                      else if ( mt < 1 ) {
                        mt = 0;
                      }

                      yindex.css({ 'margin-top': mt });
                    });
                }
                else if ( media.leftLarge ) {
                  $win.off('scroll.yindex');
                  yindex.css({ 'margin-top': null });
                }
              })
            .trigger('formatchange.yindex');
            */
			}
		};

		const initEditedSearch = function() {
			$qsearch.find('form.boxbody').editedSearch({
				ajaxSearchUrl: /^\.\//.test(Req.localPath)
					? 'ajax-searchresults.html'
					: '/leit/ritstyrdar-leitarnidurstodur',
				editedSearchSelector: '.flytileit',
				minSearchLength: 2,
			});
			$qsearch.find('.fi_txt input').on('focusin', function(/*e*/) {
				if (media.isLarge && $html.is('.mnav-open')) {
					_closeMnav();
				}
			});
		};

		const initStafflist = function() {
			const stafflist = $('.stafflist .boxbody');
			if (stafflist.length) {
				stafflist.Req(Req.localPath + 'filters/filter-staff.js', function() {
					this.staffFilterMagic();
				});
			}
		};

		const prepCalendar = function() {
			const cal = $('.calendar-full');
			const calview = $('.calview');

			if (cal.length) {
				const wdays = cal.find('th > abbr');
				wdays.each(function() {
					$(this)
						.text($(this).attr('title'))
						.wrapInner('<span>')
						.zap();
				});
				cal.find('tbody td').each(function() {
					$(this).wrapInner('<div class="day" />');
				});

				$('<div class="pgrwrap" />')
					.append(
						cal
							.find('h4,.paging')
							.get()
							.reverse()
					)
					.prependTo(cal.find('> .boxbody'));
			}

			if (calview.length) {
				const calPos = $pgmain.find('.calendar-full,.eventlist').first();
				if (calPos.length) {
					calview.prependTo(calPos);
				} else {
					calview.remove();
				}
			}
		};

		const prepEventlistHome = function() {
			const elist = $('.eventlist-home');

			if ($html.is('.home') && elist.length) {
				const elistBody = elist.find('.boxbody');
				const eContainer = '<div class="wrap"/>';
				const imgContainer = '<div class="wrap-img"></div>';
				const ebgImage = $('.eventlist-background');

				elist.append(eContainer);
				elist.find('.wrap').append(elistBody);
				elist.find('.wrap').append(imgContainer);
				const ebgImageSrc = ebgImage.find('img').attr('src');
				$('.wrap-img').css({ 'background-image': 'url(' + ebgImageSrc + ')' });
			}
		};

		const prepTilkynningarHome = function() {
			const tilkynningar = $('.tilkynningar');
			if ($html.is('.home') && tilkynningar.length) {
				tilkynningar.find('.item').each(function() {
					$(this)
						.find('h3, .summary')
						.wrapAll('<div class="text-wrapper"></div>');
				});
			}
		};

		const contactLinks = function() {
			$('.contact-button').on('click', function(e) {
				e.preventDefault();
				$html.toggleClass('show-contact-links');
				$html.removeClass('show-contact-links-init');
			});

			if ($html.is('.home') && !loggedIn) {
				setTimeout(function() {
					$html.addClass('show-contact-links');
				}, 5000);
			}
		};

		// Útboðsgagna hax
		// Ex: /stjornsysla/utgefid-efni/auglysingar/nr/8111
		const _postUtbodsgognForm = function(
			utbodsGogn,
			registerform,
			requestedMaterial,
			title,
			auto,
			modal
		) {
			utbodsGogn.removeClass('notrequested');
			utbodsGogn.find('a').each(function() {
				$(this).attr('href', $(this).attr('data-href'));
			});

			utbodsGogn.removeClass('notrequested');
			requestedMaterial[title] = 1;
			db.set('ss', 'requestedMaterial', requestedMaterial);

			$.post(
				registerform.attr('action'),
				registerform.serialize() + '&justPicPos=pgmain'
			).done(function(data) {
				if (!auto) {
					data = $(data).find('.thankyou');
					registerform.after(data).detach();
					if (registerform.find('#remember').is(':checked')) {
						const user = {
							name: registerform.find('[name="nafn"]').val(),
							email: registerform.find('[name="netfang"]').val(),
							remember: registerform.find('#remember').is(':checked'),
						};
						db.set('ss', 'user', user);
					}
					if (modal) {
						setTimeout(function() {
							modal.fickle('close');
						}, 4000);
					}
				}
			});
		};

		const initUtbodsgogn = function() {
			const utbodsGogn = $('.article--utbod .relatedfiles');
			if (utbodsGogn.length) {
				const activeUser = db.get('ss', 'user');
				const requestedMaterial = db.get('ss', 'requestedMaterial');
				const title = $('h1:first').text();
				let modal;

				const registerform = $(
					'<form action="/view/extensions/forms/formhandler" method="post">' +
						'<input name="formTag" value="FRM_Utbodsgogn" type="hidden"><input name="thank_you_page" value="/takk" type="hidden"><input name="utbodsgogn" value="' +
						title +
						'" type="hidden">' +
						'<p><strong>Ef breytingar verða eða viðaukar bætast við gögnin verða þeir sendir til þeirra sem hafa sótt gögnin hér.</strong></p>' +
						'<div class="fi_txt req"><label for="cf_name"><abbr class="req" title="Þarf að fylla út: ">*</abbr>Nafn:</label><input name="nafn" id="cf_name"></div>' +
						'<div class="fi_txt fi_email req"><label for="cf_email"><abbr class="req" title="Þarf að fylla út: ">*</abbr>Netfang:</label><input name="netfang" id="cf_email" type="email"></div>' +
						'<div class="fi_chk"><input id="remember" value="yes" type="checkbox" checked /><label for="remember">Muna eftir mér</label></div>' +
						'<div class="fi_btn"><button type="button">Skrá mig</button></div></form>'
				);

				if (!requestedMaterial[title]) {
					utbodsGogn.addClass('notrequested');
				}

				if (!activeUser.email) {
					utbodsGogn
						.addClass('notregistered')
						.find('a')
						.each(function() {
							$(this).attr('data-href', $(this).attr('href'));
							$(this).attr('href', '#');
						});

					registerform
						.autoValidate()
						.on('submit', function(e) {
							e.preventDefault();
						})
						.on('customsubmit', function() {
							if (registerform.isValid()) {
								utbodsGogn.removeClass('notregistered');
								_postUtbodsgognForm(
									utbodsGogn,
									registerform,
									requestedMaterial,
									title,
									false,
									modal
								);
							}
						})
						.on('click.submit', '.fi_btn > button', (e) => {
							e.preventDefault();
							registerform.trigger('customsubmit');
						});

					utbodsGogn.on('click', 'a', function(e) {
						if (utbodsGogn.is('.notregistered')) {
							// popup register form before fetching files
							e.preventDefault();
							const link = $(this);
							modal = $.getModal({
								opener: link,
								content: registerform,
								fickle: {
									fadein: 350,
									fadeout: 250,
								},
								onOpen: function() {},
							});
							modal.addClass('utbod-pop').fickle('open');
						} else if (activeUser.email && utbodsGogn.is('.notrequested')) {
							// auto register if user info is available, then just fetch the files
							registerform.find('input[name="nafn"]').val(activeUser.name);
							registerform.find('input[name="netfang"]').val(activeUser.email);
							_postUtbodsgognForm(
								utbodsGogn,
								registerform,
								requestedMaterial,
								title,
								true
							);
						} else {
							// just fetch the files
						}
					});
				}
			}
		};

		const prepFundargerdir = function() {
			const $fundargerdir = $('.fundargerdir .boxbody');

			if ($fundargerdir.length) {
				const $fundargerdirDisclaimer = $('.fundargerdir-disclaimer .boxbody').addClass(
					'disc'
				);
				$fundargerdir.append($fundargerdirDisclaimer);
			}
		};

		const privacyBanner = function(root) {
			const pBanner = root.find('.pgfoot .privacy');

			if (!$.cookie('privacynotify')) {
				pBanner.find('.closethis').on('click', function(e) {
					e.preventDefault();
					$('html').removeClass('showing-privacy-banner');
					$.cookie('privacynotify', '1', { expires: 180, path: '/' });
				});
				setTimeout(function() {
					$('html').addClass('showing-privacy-banner');
				}, 500);
			}
		};

		const filterArticlesByTags = function(root) {
			if ($html.hasClass('filter-by-tags')) {
				const $taglists = root.find('.taglist');
				const $itemsListBody = root.find('.articlelist.tofilter .boxbody');

				$taglists.wrapAll('<div class="taglistwrapper"></div>');
				$html.on('click', function(e) /*e*/ {
					if ($(e.target).closest('.taglist').length === 0) {
						// clicks outside the lists close all
						$taglists.removeClass('is-open');
					}
				});

				// prep article-list

				$itemsListBody.find('.item').each(function() {
					const item = $(this);
					if (item.find('.img').length) {
						item.addClass('hasimg');
					}
					item.find('.meta').insertAfter(item.find('.fulltext'));
					item.find('.subtitle').insertAfter(item.find('h3 > a'));
				});
				const $itemClones = $itemsListBody.find('.item').clone(true); // withDataAndEvents

				const _checkForTextMatch = function(item, query) {
					if (!query) {
						return true; // always match when query is empty
					}
					const texts = item
						.find('h3 > a, .subtitle, .fulltext')
						.text()
						.trim()
						.toLowerCase();
					if (texts.indexOf(query) >= 0) {
						return true;
					} else {
						return false;
					}
				};

				// search/filter logic
				const _updateItemList = function(query) {
					// read current tags from taglists
					const tagArr = [];
					$taglists.each(function() {
						const myTag = $(this).attr('data-chosentag');
						if (myTag) {
							tagArr.push(myTag.toLowerCase());
						}
					});

					// console.log(tagArr, query);

					// always reset to the initial list (clones)
					$itemsListBody.empty();
					$itemClones.each(function() {
						const $entry = $(this);

						if (query) {
							_checkForTextMatch($entry, query);
						}

						let isMatching = false;
						if (tagArr.length) {
							// check on first tag
							$entry.find('.tags a').each(function() {
								if (
									$(this)
										.text()
										.toLowerCase() === tagArr[0]
								) {
									isMatching = _checkForTextMatch($entry, query);
									// defaults to true (unless query does not match)
								}
							});
							if (tagArr[1] && isMatching) {
								isMatching = false;
								// loop again to see if second tag also matches
								$entry.find('.tags a').each(function() {
									if (
										$(this)
											.text()
											.toLowerCase() === tagArr[1]
									) {
										isMatching = _checkForTextMatch($entry, query);
										// defaults to true (unless query does not match)
									}
								});
							}
						} else {
							// no tags active
							isMatching = _checkForTextMatch($entry, query);
							// defaults to true (unless query does not match)
						}

						// if item still matches, add to boxbody
						if (isMatching) {
							$entry.appendTo($itemsListBody);
						}
					});
					$itemsListBody.find('.item h3 > a').on('click', function(e) {
						// for some reason this event was sometimes dropped when added on first run
						// => only apply it after inserting
						e.preventDefault();
						$(this)
							.parents('.item')
							.toggleClass('opened');
					});
					$itemsListBody.find('.item .fulltext').on('click', function(e) {
						const item = $(this).parents('.item');
						if (!item.hasClass('opened')) {
							item.addClass('opened');
						}
					});
					$itemsListBody.find('.item .tags > a').on('click', function(e) {
						// TEMPORARY FIX
						// Clicking a tag results in a server-filtered list, where the js-filter no longer works
						e.preventDefault();
					});
					if (!$itemsListBody.find('.item').length) {
						$itemsListBody.append(
							'<p>Ekkert fannst sem passar við leitarskilyrðin. Líklega eru þau of þröngt afmörkuð.</p>'
						);
					}
				};

				_updateItemList(); // inital run to activate event listeners

				// format taglists, set inital state and activate listeners
				$taglists.each(function() {
					const thisList = $(this);
					const ulList = thisList.find('.level1');
					const listHeading = thisList.find('.boxhead').text();

					// inject button
					const toggleButton = $(
						'<button class="taglistheader">' + listHeading + '</button>'
					);
					toggleButton.attr('data-fallback', listHeading);
					toggleButton.on('click', function(e) {
						e.preventDefault();
						thisList.toggleClass('is-open');
					});
					ulList.before(toggleButton);

					// track clicks
					thisList.find('a').on('click', function(e) {
						// console.log('Got click: ' + $(this).text());

						// update visible text in button
						// trigger update on search results when needed
						e.preventDefault();
						const thisLink = $(this);
						const thisParent = thisLink.parent('li');
						if (!thisParent.hasClass('last-clicked') && !thisParent.hasClass('home')) {
							toggleButton.text(thisLink.text());
							// use last-clicked rather than current, since current might be an initial state (existing on load)
							thisList.find('li.last-clicked').removeClass('last-clicked');
							thisParent.addClass('last-clicked');
							thisList.attr('data-chosenTag', thisLink.text());
							// trigger re-search (using data-chosenTag)
							_updateItemList();
							// console.log('New tag: ' + thisLink.text());
						}
						if (thisParent.hasClass('home')) {
							toggleButton.text(toggleButton.attr('data-fallback'));
							thisList.find('li.last-clicked').removeClass('last-clicked');
							thisList.removeAttr('data-chosenTag');
							// trigger re-search (falling back)
							_updateItemList();
							// console.log('Resetting: ' + thisLink.text());
						}
						$taglists.removeClass('is-open'); // always collapse (all lists) on click
					});

					const startTag = thisList.find('li.current');
					if (!startTag.hasClass('home')) {
						// initiate search if there is a current tag on load
						startTag.find('a').click();
					}
				});

				// inject a text search field in front of the first taglist
				const $textsearch = $(
					'<input id="" type="text" name="name" value="" placeholder="Leit í texta">'
				);
				$textsearch
					.insertBefore($taglists.first('.taglist'))
					.wrap('<div class="fi_txt text-filter" />');
				$textsearch.on('keyup', function(e) {
					const value = $(this)
						.val()
						.trim()
						.toLowerCase();
					if (value.length > 2) {
						_updateItemList(value);
						$textsearch.attr('data-didsearch', 'true');
					} else {
						if ($textsearch.attr('data-didsearch') === 'true') {
							// user is shortening a previous query
							_updateItemList();
							$textsearch.removeAttr('data-didsearch');
						}
					}
				});
			}
		};

		const prepHeimsmarkmidin = () => {
			if ($html.is('.heimsmarkmidin, .heimsmarkmid')) {
				// prep cta image
				const $cta = $('.heimsmarkmidin__cta');
				$cta.each(function() {
					const $this = $(this);
					const $ctaHeroImageLi = $this.find('.itm1 .imagelist .image:first-child');
					const $ctaHeroImageImg = $ctaHeroImageLi.find('.img');
					$ctaHeroImageImg
						.insertAfter($this.find('h2'))
						.addClass('heimsmarkmidin__cta__heroImage');
					$ctaHeroImageLi.remove();

					// prep cta items
					$this.find('.item').each(function() {
						$(this)
							.find('h3, .summary')
							.wrapAll($("<div class='heimsmarkmidin__cta--content'></div>"));
					});
				});

				const $newslist = $('.heimsmarkmidin__newslist');
				const $newslistItems = $newslist.find('.item').not(':first');

				$newslistItems.wrapAll($("<div class='heimsmarkmidin__newslist__items'></div>"));
				$newslist.find('.boxbody').append($('.heimsmarkmidin__newslist__items'));
				$newslist
					.find('.boxbody')
					.parent()
					.append($('.moreolder'));

				const $heimsmarkmidinList = $('.heimsmarkmidin__markmidin');
				const $heimsmarkmidinListItems = $heimsmarkmidinList.find('.item');

				$heimsmarkmidinListItems.each(function() {
					const $this = $(this);
					const $heimsmarkmidinListSummary = $this.find('.summary');
					const $heimsmarkmidinListMore = $this.find('.more');

					// $this.find('.subtitle').append($this.find('h3'));
					const $subtitle = $this.find('.subtitle');
					const $subtitleText = $subtitle.text();
					$this.find('h3 a').prepend($subtitleText + ' ');
					$heimsmarkmidinListMore.insertAfter($heimsmarkmidinListSummary);
					$subtitle.remove();
				});

				// prep article pgtop
				const $article = $('.heimsmarkmidin__article');
				$article
					.find('h1, h2, p')
					.wrapAll($('<div class="heimsmarkmidin__articleTextWrapper"></div>'));

				// prep articlelist
				const $heimsmarkmidinArticlelistItem = $('.heimsmarkmidin__articlelist .item');
				$heimsmarkmidinArticlelistItem.each(function() {
					$(this)
						.find('h3, .subtitle, .summary')
						.wrapAll($('<div class="heimsmarkmidin__articleListTextWrapper"></div>'));
				});

				$('.heimsmarkmidin__articlelist .item').each(function() {
					$(this)
						.find('.heimsmarkmidin__articleListTextWrapper h3, h4.subtitle')
						.wrapAll($('<div class="heimsmarkmidin__articleListHeading"></div>'));
				});

				// prepArticlelistLayout
				const $heimsmarkmidinArticlelist = $('.heimsmarkmidin__articlelist');
				$heimsmarkmidinArticlelist.each(function() {
					const $heimsmarkmidinArticlelistItms = $(this).find('.item');

					if ($heimsmarkmidinArticlelistItms.length > 2) {
						$(this).addClass('heimsmarkmidin__articlelistGrid');
					}
				});
			}
		};

		const netspjall = () => {
			if ($html.is('.chattest')) {
				Req(
					'https://ajax.aspnetcdn.com/ajax/signalr/jquery.signalr-2.1.2.min.js',
					'https://gb-msweb02.gardabaer.is:8085/webchat/client/FileSaver.min.js',
					'https://gb-msweb02.gardabaer.is:8085/webchat/client/webchat.min.js'
				);

				setTimeout(() => {
					const chat = new $.webChat({
						queue: 'WEBCHAT',
					});

					const originalLocalize = chat.localize;

					// eslint-disable-next-line complexity
					chat.localize = function(key) {
						switch (key) {
							//Chat heading text
							case 'MAN_HDR':
								return 'Netspjall'; // Live Chat
							//Name placeholder: default text inside the name input box.
							case 'NME_PLC':
								return 'Nafnið þitt'; // Your Name
							//Invalid name message text.
							case 'INV_NME':
								return 'Sláðu inn nafnið þitt'; //Type your name
							//Invalid e-mail address message text.
							case 'INV_EML':
								return 'Ógilt netfang'; //Invalid email address
							//Missing e-mail address message text.
							case 'UNS_EML':
								return 'Sláðu inn netfangið þitt'; //Type your email address
							//Email placeholder: default text inside the email input box.
							case 'EML_PLC':
								return 'Netfang'; // Email Address
							//Initiate chat trigger element text.
							case 'CHT_TRG':
								return 'Hefja spjall'; // Start Chat
							//End chat trigger element text.
							case 'END_TRG':
								return 'Enda spjall'; // End Chat
							//Chat connected status message. The argument is the agent's name.
							case 'CHT_BEG':
								return 'Þú ert að tala við ... ' + arguments[1]; // You are chatting with ...
							//Chat ended status message.
							case 'CHT_END':
								return 'Spjallinu hefur verið lokað'; //e.g. Your chat session has ended
							//Send chat message trigger element text.
							case 'MSG_TRG':
								return 'Senda'; //e.g. Send
							//Waiting in queue message.
							case 'QUE_TXT':
								return 'Vinsamlegast hinkrið eftir næsta lausa þjónustufulltúa'; // Please wait for an agent to become available
							//Server error status message.
							case 'ERR_SVR':
								return 'Villa í netþjóni'; // Server error
							//Out of service status message.
							case 'QUE_OFF':
								return 'Netspjall ekki opið'; // Not in service
							//Typing indicator message (the argument is the agent's name).
							case 'TYP_IND':
								return arguments[1] + '... er að skrifa'; // ... is typing
							//Participant joined the conversation message (the argument is the name of the participant).
							case 'PTC_JND':
								return arguments[1] + '... hefur tengst spjallinu'; // ... has joined the chat
							//Participant left the conversation message (the argument is the name of the participant).
							case 'PTC_LFT':
								return arguments[1] + '... hefur yfirgefið spjallið'; // ... has left the chat
							//Agent offline message (the argument is the agent's name).
							case 'PTC_OFL':
								return arguments[1] + '... hefur misst netsambandið'; // ... has gone offline
							//Agent online (the argument is the agent's name).
							case 'PTC_ONL':
								return arguments[1] + '... er núna tengdur'; // ... is now online
							//ETA announcement (the argument is the ETA value).
							case 'ANC_ETA':
								return 'Áætlaður biðtími - ' + arguments[1]; // Estimated wait time -
							//Download chat transcript trigger element text.
							case 'TRN_TRG':
								return 'Smelltu hér til að sækja spjall textann'; // Click here to download the chat transcript
							//Confirm closing window dialog text.
							case 'PRM_UNL':
								return 'Með því að fara úr þessum glugga lokast fyrir spjallið, ertu viss?'; //Navigating away or closing this page will terminate the chat session, are you sure?
							//Confirm terminating chat dialog text.
							case 'PRM_END':
								return 'Þú ert að fara að loka spjallinu, ertu viss?'; //This will terminate the chat session. Proceed?
							// Any strings not customised/localised will use the default English strings
							case 'NIS_MSG':
								return 'Netspjallið er ekki opið í augnablikinu';
							// Queue is closed
							default:
								return originalLocalize.apply(chat, arguments);
						}
					};
				}, 2000);
			}
		};

		const airQuality = () => {
				const localId = 'STA-IS0064A';
				const apiUrl = `https://api.ust.is/aq/a/getCurrent/id/${localId}`;
				const mnav = document.querySelector('.mnav .boxbody');
				const header = document.querySelector('.pghead');
				const airQualityWrapper = document.createElement('div');
				let airQualityValue = '';
				airQualityWrapper.className = 'air-quality';

				const airValues = [
					{
						text: 'Mjög góð',
						value: 0,
					},
					{
						text: 'Góð',
						value: 25,
					},
					{
						text: 'Sæmileg',
						value: 50,
					},
					{
						text: 'Óholl fyrir viðkvæma',
						value: 75,
					},
					{
						text: 'Óholl',
						value: 100,
					},
				];

				fetch(apiUrl)
					.then((response) => response.json())
					.then((data) => {
						if (
							data[localId] &&
							data[localId].parameters &&
							data[localId].parameters['PM10']
						) {
							const pm25Data = data[localId].parameters['PM10'];

							// Convert to array and get the latest item
							const pm25Values = Object.values(pm25Data).filter(
								(item) => typeof item === 'object'
							);
							const latestPM25 = pm25Values[pm25Values.length - 1];

							airValues.forEach((element) => {
								if (latestPM25.value > element.value) {
									airQualityWrapper.classList.add(`value-${element.value}`);
									airQualityValue = element.text;
								}
							});

							// Render it as HTML
							if (mnav) {
								airQualityWrapper.innerHTML = `
									<a href="/umhverfi/loftgaedi" class="air-quality__link"><span class="air-quality__text">Loftgæði</span>
									<span class="air-quality__value">${airQualityValue}</span>
									<span class="air-quality__color"></span></a>
								`;
							}
							header.appendChild(airQualityWrapper);
						} else {
							console.error('No PM2.5 data found');
						}
					})
					.catch((error) => console.error('Error fetching data:', error));

				// $win.on('formatchange.imagebanner', function(/*e*/) {
				// 	if (
				// 		media.format === 'phone' ||
				// 		media.format === 'phablet' ||
				// 		media.format === 'tablet'
				// 	) {
				// 		header.appendChild(airQualityWrapper);
				// 	} else {
				// 		mnav.appendChild(airQualityWrapper);
				// 	}
				// });
		};

		// =========================================================================================================================
		//   Run Init Actions
		// =========================================================================================================================

		!loggedIn && prepHeader();
		initNavScroll();

		$doc
			.on('domupdated.main', function(e, updatedFragment) {
				const root = $(updatedFragment || this);

				// Scripts sem hafa áhrif á article content eiga ekki að keyra þegar notendur eru loggedIn vegna ritilsins.
				!loggedIn &&
					root.query('table:not(.fundargerdir table)').wrap('<div class="tablewrap" />');
				!loggedIn &&
					root.query('ol').attr('data-oltype', function() {
						return this.type || '';
					}); // enable fancy styling on <ol> markers....
				!loggedIn && root.query('.netfang').mailtoEnabler(); //enable mailto links

				!loggedIn && prepArticleContent(root); // <- videolinks verður að keyra á undan anchortags
				!loggedIn && tagFileAndExternalLinks(root); // Þarf að keyrast soldið seint vegna ga tracking

				!loggedIn && prepArticlelists(root);
				!loggedIn && prepTilkynningarHome(root);
				!loggedIn && prepFundargerdir(root);
				!loggedIn && filterArticlesByTags(root);

				!loggedIn && privacyBanner(root);
				!loggedIn && netspjall();

				initForms(root);
			})
			.trigger('domupdated.main');

		// prepHomebanner();
		collapseSitemap();
		$.initMobileMenu({ mediaGroup: 'HeaderSmall' });
		initMnav();
		handleTelephoneLinks(); // <- depends on formatChange
		prepYearindex();
		prepCalendar();
		prepEventlistHome();
		initEditedSearch();
		initStafflist();
		contactLinks();
		prepHeimsmarkmidin();
		airQuality();

		initUtbodsgogn();

		$('.didithelp').quickFeedback();

		$('a.netspjall').on('click', function() {
			const netspjall = window.open(
				this.href,
				'netspjall',
				'height=550,width=700,location=no,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0'
			);
			netspjall.focus();
			return false;
		});

		$('html').removeClass('beforejsinit'); //remove flicker trick

		$.fixSkiplinks && $.fixSkiplinks();

		// // Loading body class scripts
		// Req.loadPageScripts({ folder:'' });
	}
);
